import React from "react";
import HeaderBox from "../Home/HeaderBox";
import Header from "../Home/Header";
import Navbar from "../commons/Navbar";
import styles from "./preview.module.css";
import logo from "../Home/assets/logo.png";

const renderToolDiscTypes = (types) => {
  if (!types) return null;

  if (Array.isArray(types)) {
    return types.map((type, index) => (
      <div key={index} className={styles.toolDiscItem}>
        {type.trim()}
      </div>
    ));
  }

  if (typeof types === "string") {
    return types.split(",").map((type, index) => (
      <div key={index} className={styles.toolDiscItem}>
        {type.trim()}
      </div>
    ));
  }

  return <div className={styles.toolDiscItem}>{String(types)}</div>;
};

const Preview = () => {
  const data = [
    {
      articleNo: "SD7403",
      itemName: "ATH 12-12",
      A: 12,
      B: 12,
      C: 24,
      D: 12,
      E: 56,
      F: 31,
      G: 43,
      H: 4,
      J: 12,
      toolDiscType1: "TD 50-8-12",
      toolDiscType2: "",
    },
    {
      articleNo: "SD0403",
      itemName: "ATH 16-16",
      A: 16,
      B: 16,
      C: 32,
      D: 16,
      E: 66,
      F: 37,
      G: 51,
      H: 5,
      J: 16,

      toolDiscType1: "TD 50-8-16, TD 63-8-16",
      toolDiscType2: "TD 63-12-16, HTD 63-12-16",
    },
    {
      articleNo: "SD0503",
      itemName: "ATH 20-20",
      A: 20,
      B: 20,
      C: 40,
      D: 16,
      E: 76,
      F: 45,
      G: 60,
      H: 5,
      J: 20,

      toolDiscType1:
        "TD 50-8-20, TD 63-8-20 , TD 80-8-20, HTD 63-8-20, HTD 80-8-20",
      toolDiscType2: "TD 80-12-20, HTD 80-12-20",
    },
    {
      articleNo: "SD33503",
      itemName: "ATH 25-25 L60",
      A: 25,
      B: 25,
      C: 50,
      D: 25,
      E: 90,
      F: 55,
      G: 60,
      H: 5,
      J: 25,
      toolDiscType1: "TD 63-25-25",
      toolDiscType2: "",
    },
    {
      articleNo: "SD1403",
      itemName: "ATH 25-25",
      A: 25,
      B: 25,
      C: 50,
      D: 25,
      E: 92,
      F: 55,
      G: 80,
      H: 5,
      J: 25,

      toolDiscType1:
        "TD 80-8-25, TD 100-8-25 , HTD 80-8-25, HTD 100-8-25, HTD 125-8-25",
      toolDiscType2: "TD 100-12-25, TD 125-12-25, HTD 100-12-25, HTD 125-12-25",
    },
    {
      articleNo: "SD2303",
      itemName: "ATH 32-32",
      A: 32,
      B: 32,
      C: 64,
      D: 25,
      E: 114,
      F: 65,
      G: 95,
      H: 5,
      J: 32,

      toolDiscType1: "TD 100-8-32, TD 125-8-32, HTD 125-8-32",
      toolDiscType2: "TD 125-12-32, HTD 125-12-32",
    },
    {
      articleNo: "SD3003",
      itemName: "ATH 40-40",
      A: 40,
      B: 40,
      C: 80,
      D: 25,
      E: 142,
      F: 75,
      G: 95,
      H: 5,
      J: 40,

      toolDiscType1: "TD 125-12-40",
      toolDiscType2: "",
    },
    {
      articleNo: "SD53645",
      itemName: "ATH 160-32",
      A: 32,
      B: 32,
      C: 64,
      D: 40,
      E: 142,
      F: 74,
      G: 124,
      H: 5,
      J: 32,

      toolDiscType1: "TD 160-8-32, TD 160-12-40",
      toolDiscType2: "",
    },
    {
      articleNo: "SD12602",
      itemName: "ATH 160-40",
      A: 40,
      B: 40,
      C: 80,
      D: 40,
      E: 142,
      F: 74,
      G: 124,
      H: 5,
      J: 40,

      toolDiscType1: "TD 160-8-40 , TD 160-12-40",
      toolDiscType2: "",
    },
  ];
  return (
    <div className="">
      {/* <HeaderBox /> */}
      <div className={styles.previewHeader}>
        <div className="header-box">
          <a href="https://www.sphoorti.com/">
            <img
              src={logo}
              alt="Sphoorti Machine Tools – precision tool holders and discs"
              href=""
            />
          </a>
        </div>
        {/* <Header /> */}
        <Navbar
        // setNavigationId={setNavigationId}
        // setParentProduct={setParentProduct}
        />
      </div>

      <div className="container-fluid" id={styles.productMobileContainer}>
        <div className={`${styles.ContentContainer}`}>
          <div className={`${styles.ContentContainerDesc}`}>
            <h2>ATH (AXIAL TOOL HOLDER)</h2>
          </div>

          <div className={styles.ProductDataContainer2}>
            <img
              alt={"dfghjkl"}
              src={`https://ik.imagekit.io/ckybshjf7y/Spoorthi.jpg?updatedAt=1752844893352`}
            />

            <table style={{ marginTop: "3%" }}>
              {/* <thead className="product-table-column"></thead> */}

              <thead className="product-table-column">
                <tr>
                  <th>Article No.</th>
                  <th>Item Name</th>
                  <th>A</th>
                  <th>
                    B<br />
                    <span>(TOOL SIZE)</span>
                  </th>
                  <th>C</th>
                  <th>D</th>
                  <th>E</th>
                  <th>F</th>
                  <th>G</th>
                  <th>H</th>
                  <th>J</th>
                  <th className={styles.toolDiscTypeHead} colspan="2">
                    Tool Disc Type
                  </th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{item.articleNo}</td>
                    <td>{item.itemName}</td>
                    <td>{item.A}</td>
                    <td>{item.B}</td>
                    <td>{item.C}</td>
                    <td className={styles.toolDiscTypeHead}>{item.D}</td>
                    <td>{item.E}</td>
                    <td>{item.F}</td>
                    <td>{item.G}</td>
                    <td>{item.H}</td>
                    <td>{item.J}</td>
                    {/* <td className={styles.toolDiscCell}>
                {item.toolDiscType2 ? (
                  <>
                    <td>
                      <div className={styles.toolDiscType}>
                        {renderToolDiscTypes(item.toolDiscType1)}
                      </div>
                    </td>
                    <td>
                      <div className={styles.toolDiscType}>
                        {renderToolDiscTypes(item.toolDiscType2)}
                      </div>
                    </td>
                  </>
                ) : (
                  <div className={styles.toolDiscType}>
                    {renderToolDiscTypes(item.toolDiscType1)}
                  </div>
                )}
              </td> */}

                    {item.toolDiscType2 ? (
                      <>
                        <td>{renderToolDiscTypes(item.toolDiscType1)}</td>

                        <td>{renderToolDiscTypes(item.toolDiscType2)}</td>
                      </>
                    ) : (
                      <>
                        <td className={styles.spanTwoColl} colspan="2">
                          {renderToolDiscTypes(item.toolDiscType1)}
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            <div className={styles.notes}>
              <p>
                * Made out of Medium Carbon Steel, Forged & Toughened to 20±2
                HRC
              </p>
              <p>* Customised design can be given upon request</p>
              <p>
                * Inch series Axial Tool Holders are also available upon request
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preview;
